//
//
//
//
// 单个仪表盘
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '93%'
    },
    top: {
      type: String,
      default: '20px'
    },
    left: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {
    var _this = this;

    // console.log('dial')
    setTimeout(function () {
      _this.initBarChart();
    }, 1000); // this.$nextTick(() => {})
  },
  methods: {
    initBarChart: function initBarChart(data, title, color) {
      var xAxisData = ['2018-01', '2018-02', '2018-03', '2018-04', '2018-05', '2018-06', '2018-07', '2018-08', '2018-09', '2018-10', '2018-11', '2018-12'];
      var legendData = ['投诉量', '解决量', '投诉解决率', '投诉量1', '解决量1', '投诉解决率1', '投诉量2', '解决量3', '投诉解决率3'];
      var title = "多横向折线图";
      var serieData = [];
      var metaDate = [[120, 140, 100, 120, 300, 230, 130, 170, 140, 120, 300, 230], [200, 120, 300, 200, 170, 300, 200, 180, 200, 190, 300, 200], [100, 200, 140, 300, 200, 180, 100, 300, 230, 130, 100, 300], [20, 40, 10, 12, 30, 23, 13, 17, 14, 12, 30, 23], [20, 10, 30, 20, 10, 30, 20, 18, 20, 19, 30, 20], [10, 0, 10, 30, 20, 18, 10, 30, 23, 13, 10, 30], [12, 15, 2, 5, 22, 5, 8, 5, 1, 2, 2, 5], [45, 4, 15, 8, 1, 5, 45, 12, 4, 5, 12, 545], [4, 5, 45, 1, 8, 5, 15, 25, 65, 45, 65, 85]];

      for (var v = 0; v < legendData.length; v++) {
        var serie = {
          name: legendData[v],
          type: 'line',
          symbol: "circle",
          symbolSize: 10,
          data: metaDate[v]
        };
        serieData.push(serie);
      }

      var colors = ["#00557f", "#0055ff", "#00aaff", "#00ffff", "#aaffff", "#ffffff"];
      var option = {
        // backgroundColor: '#0f375f',
        // title : {text: title,textAlign:'left',textStyle:{color:"#fff",fontSize:"16",fontWeight:"normal"}},
        legend: {
          show: true,
          left: "right",
          data: legendData,
          y: "0%",
          itemWidth: 18,
          itemHeight: 12,
          textStyle: {
            color: "#fff",
            fontSize: 14
          }
        },
        color: colors,
        grid: {
          left: '2%',
          top: "20%",
          bottom: "5%",
          right: "5%",
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: [{
          type: 'category',
          // axisLine: { show: true,lineStyle:{ color:'#6173A3' }},
          axisLabel: {
            textStyle: {
              color: '#9ea7c4',
              fontSize: 14
            }
          },
          // axisTick : {show: false},
          data: xAxisData
        }],
        yAxis: [{
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#9ea7c4',
              fontSize: 14
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#6173A3'
            }
          }
        }],
        series: serieData
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};